import { Loader2 } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { TaskAiAnalysis } from "@recobra/schemas/task";

import { TruncatedText } from "../../lib";
import { AiReasoningTooltip } from "./AiReasoningTooltip";

/**
 * One line reporting an AI suggestion, or its pending/failed state before
 * a suggestion exists — shared by every field/resolution a reviewer sees an
 * AI suggestion for, so they all read and behave the same way.
 */
export const AiSuggestionStatus: FC<{
  value?: string;
  reasoning?: string;
  status?: TaskAiAnalysis["status"];
  className?: string;
}> = ({ value, reasoning, status, className = "text-sm" }) => {
  if (value) {
    return (
      <p className={`flex items-center gap-1.5 ${className} text-muted-foreground`}>
        <TruncatedText text={m.ai_suggestion_label({ value })} className="min-w-0" />
        {reasoning ? <AiReasoningTooltip reasoning={reasoning} /> : null}
      </p>
    );
  }

  if (status === "failed") {
    return (
      <p className={`${className} text-destructive`}>
        {m.task_analysis_status_label({ status: "failed" })}
      </p>
    );
  }

  return (
    <p className={`flex items-center gap-1.5 ${className} text-muted-foreground`}>
      <Loader2 className="h-3 w-3 animate-spin" />
      <span>{m.task_analysis_status_label({ status: "pending" })}</span>
    </p>
  );
};
